import {
  TyrianApp
} from '../js/target/scala-3.6.3/hedgehogs-dag-visitor-demo-fastopt/main.js';

TyrianApp.launch("myapp");
